export var PipelinePhase;
(function (PipelinePhase) {
    PipelinePhase["Pre"] = "pre";
    PipelinePhase["Regular"] = "regular";
    PipelinePhase["Post"] = "post";
})(PipelinePhase || (PipelinePhase = {}));
